import { apiClient, API_BASE_URL } from './client'

/**
 * Blobs are served by `GET /v1/files/*path` behind the session, not by a
 * signed storage URL — so an <img> needs the Authorization header, which
 * means fetching the bytes rather than handing the URL to the browser.
 *
 * Ported from `lib/services/api/files_api.dart`.
 */
export const filesApi = {
  urlFor(path: string): string {
    if (!path) return ''
    const clean = path.startsWith('/') ? path.slice(1) : path
    return `${API_BASE_URL}/v1/files/${clean}`
  },

  authHeaders(): Record<string, string> {
    return apiClient.authHeaders()
  },

  /** Fetches a blob and returns an object URL for it. The caller revokes it. */
  async objectUrl(path: string, signal?: AbortSignal): Promise<string> {
    const { data } = await apiClient.axios.get<Blob>(this.urlFor(path), {
      responseType: 'blob',
      signal,
    })
    return URL.createObjectURL(data)
  },
}
